export default __webpack_public_path__ + "static/Daily-Digi-5d18b0c4a25368ad0739e730a8d6ca07.png";